import Icon from '../../components/Icon.vue'

Icon.register({"brands/css3-alt":{"width":384,"height":512,"paths":[{"d":"M0 32L34.9 427.8 192 480 349.1 427.8 384 32H0zM313.1 112L308.3 159.3 193 208.6 192.7 208.7H304.2L291.4 355.3 193.2 384 94.4 354.8 88 280.9H136.9L140.1 319.2 192.7 332.5 247.4 317.1 251.1 255.5 84.8 255V254.9L84.6 255 81 208.7 193.1 162 199.6 159.3H76.7L70.9 112H313.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-awesome@3.0.0@vue-awesome/icons/brands/css3-alt.js
// module id = null
// module chunks = 